module.exports = "https://static.wanderu.com/static/media/magnifying-glass.d707bd8b.svg";